export enum UserAdminLevel {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  INACTIVE_USER = 'INACTIVE_USER',
}
